import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { MARKED_OPTIONS, provideMarkdown } from 'ngx-markdown';

import { provideRouter } from '@angular/router';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { provideAnimations } from '@angular/platform-browser/animations';
import { withInterceptors, provideHttpClient } from '@angular/common/http';
import {
  inject,
  provideAppInitializer,
  type ApplicationConfig,
  provideZonelessChangeDetection,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';

import { routes } from './routes';

import { provideAuthSession } from '@core/auth';
import { RuntimeConfigService } from '@shared/config';
import { authInterceptor, baseUrlInterceptor, refreshInterceptor, unwrapApiEnvelopeInterceptor } from '@core/http';
import {
  provideSvgSprite,
  provideAppTranslation,
  provideAppErrorHandler,
  provideRouteReuseStrategy,
} from '@core/providers';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideRouteReuseStrategy(),
    provideAppErrorHandler(),
    provideAppTranslation(),
    provideSvgSprite(),
    provideAppInitializer(() => inject(RuntimeConfigService).loadConfig()),
    provideHttpClient(
      withInterceptors([baseUrlInterceptor, authInterceptor, refreshInterceptor, unwrapApiEnvelopeInterceptor]),
    ),
    provideAnimations(),
    provideAuthSession(),
    MessageService,
    providePrimeNG({
      translation: {
        dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      },
    }),
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    provideMarkdown({
      markedOptions: {
        provide: MARKED_OPTIONS,
        useValue: { breaks: false },
      },
    }),
  ],
};
